// @ts-nocheck

import { createSelector } from 'reselect';

import { setKLOrientationPaginationIndex } from '../../actions/kl';
import { selectKLOrientationPaginationIndex } from '../misc';
import { selectKLUserOrientation } from '../user';

const getDispatchFromProps = (_, { dispatch }) => dispatch;

const selectUserProgressionIndex = createSelector([selectKLUserOrientation], (orientation) => orientation.length - 1);

const selectSetIndex = createSelector(
  [getDispatchFromProps, selectUserProgressionIndex, selectKLOrientationPaginationIndex],
  (dispatch, userProgressionIndex, currentIndex) => (index) => {
    if (index !== currentIndex && index <= userProgressionIndex) {
      dispatch(setKLOrientationPaginationIndex(index));
    }
  },
);

const selectKLOrientationPaginationProps = createSelector(
  [selectKLOrientationPaginationIndex, selectUserProgressionIndex, selectSetIndex],
  (index, progressionIndex, setIndex) => ({
    index,
    progressionIndex,
    setIndex,
  }),
);

export default selectKLOrientationPaginationProps;
